import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchAdminThunk } from "slices/userSlice";
import { MdSkipNext, MdSkipPrevious } from "react-icons/md";
import Card from "components/card";
import { deleteSubAdminThunk } from "slices/userSlice";
import PopUpAlertModal from "components/modals/popUpAlertModal";
import { notify } from "common/toastUtil";
import { clearUniqueCode } from "slices/userSlice";
import { columnsDataColumns } from "../tables/variables/columnsData";
import ColumnsTable from "../tables/components/ColumnsTable";
import { fetchAudioLogListThunk } from "slices/mediaLogsSlice";
import VideoLogTable from "./videoLogTable";
import { fetchVideoLogListThunk } from "slices/mediaLogsSlice";
const VidoeLogs = () => {
     const dispatch = useDispatch();
    const audioLogs = useSelector((state) => state?.media?.data?.data || []);
    console.log("audioLogs", audioLogs)
    const [adminId, setAdminId] = useState("");
    const [openAlert, setOpenAlert] = useState(false)

    const [pageB, setPageB] = useState(1); // Agent table
    const { uniqueCode, data } = useSelector((state) => state?.users)
    const itemsPerPage = 5;


    const pageAudio = audioLogs.slice(
        (pageB - 1) * itemsPerPage,
        pageB * itemsPerPage
    );
    const totalPagesB = Math.ceil(audioLogs.length / itemsPerPage);
    useEffect(() => {
        dispatch(fetchVideoLogListThunk())
    }, [dispatch])
    const deleteSubAdmin = (id) => {
        setAdminId(id)
        if (id) {
            setOpenAlert(true)
        }

    }
    useEffect(() => {
        if (data?.status === 201) {
            notify("success", data?.message);
            dispatch(fetchAdminThunk());
        }
        if (data?.status === 200 && uniqueCode) {
            notify("success", data?.message);
            dispatch(fetchAdminThunk());
        }

        if (data?.status !== 200 && data?.status !== 201 && uniqueCode) {
            notify("error", data?.message);
        }

        dispatch(clearUniqueCode());
    }, [data?.status, data?.message, uniqueCode, dispatch]);
    return (
      <div>
            <PopUpAlertModal openAlert={openAlert} setOpenAlert={setOpenAlert} title="Are you sure you want to delete this Sub Admin?" clickHandler={() => dispatch(deleteSubAdminThunk(adminId))} />
            <div className="flex justify-content-around w-full mt-4">
                <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold"> Total Video Logs:{audioLogs?.length || 0}</Card>
                <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
                    Pending: {audioLogs?.filter(log => log.status === 'pending').length}
                </Card>

                {/* Active Logs */}
                <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
                    Active: {audioLogs?.filter(log => log.status === 'active').length}
                </Card>

                {/* Completed Logs */}
                <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
                    Completed: {audioLogs?.filter(log => log.status === 'completed').length}
                </Card>

                {/* Cancelled Logs */}
                <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
                    Cancelled: {audioLogs?.filter(log => log.status === 'cancelled').length}
                </Card>

            </div>
            <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
                {pageAudio?.length > 0 && <div>
                    <VideoLogTable
                        title="Video Logs Table"
                        columnsData={columnsDataColumns}
                        tableData={pageAudio?.length > 0 ? pageAudio : []}
                        deleteSubAdmin={deleteSubAdmin}
                    />
                    {/* Pagination controls */}
                    {totalPagesB > 1 && (
                        <div className="flex gap-2 justify-center my-2">
                            <button onClick={() => setPageB(p => Math.max(1, p - 1))} disabled={pageB === 1}>
                                <MdSkipPrevious />
                            </button>
                            {Array.from({ length: totalPagesB }, (_, i) => (
                                <button key={i + 1} onClick={() => setPageB(i + 1)} className={i + 1 === pageB ? 'font-bold' : ''}>
                                    {i + 1}
                                </button>
                            ))}
                            <button onClick={() => setPageB(p => Math.min(totalPagesB, p + 1))} disabled={pageB === totalPagesB}>
                                <MdSkipNext />
                            </button>
                        </div>
                    )}
                </div>}
            </div>
        </div>
    )
}

export default VidoeLogs
